<template>
    <div class="flex w-full mt-3 ml-1 pl-0 pr-0">
        <div class="w-full p-0" style="height: 400px; overflow-y: auto;">
            <div class="w-full pl-0">
                <span id="headerDepartmentName" class="card-title text-secondary font-italic" style="font-size: 15px;">{{ departmentName }}</span>
            </div>
            <div class="w-full pr-0 m-0">
                <div class="w-full p-0" v-for="(data, index) of users" v-bind:key="index">
                    <span class="xl:w-11/12 lg:w-10/12 w-11/12 p-0 mt-2 mb-1"><i class="fas fa-user" style="color: #a6a6a6;"></i> <span class="hide-text" style="width: 100px;">{{ data.fullName }}</span></span><i class='fas fa-times text-muted offset-8 col-1' style="" @click="removeEmployee(data.profileId)"></i>
                </div>
                <span v-if="Object.keys(users).length === 0 && departmentName !== defaultMsg" class="font-italic">Geen werknemers in deze afdeling</span>
            </div>
            <div class="w-full pl-0 ml-0 mt-2" v-if="Object.keys(subusers).length > 0">
                <span id="headerDepartmentName" class="card-title text-secondary" style="font-size: 15px;">Subafdelingen</span>
            </div>
            <div class="w-full pr-0 m-0">
                <div class="w-full p-0" v-for="(data, index) of subusers" v-bind:key="index">
                    <span class="w-11/12 p-0 mt-2 mb-1"><i class="fas fa-user" style="color: #a6a6a6;"></i> {{ data.fullName }}</span>
                </div>
            </div>
        </div>
        <div class="flex w-full p-0">
            <div v-if="departmentName !== defaultMsg" class="offset-xl-6 offset-lg-1 w-full text-muted p-0" style="font-size: 12px;">
                <label for="open_add_employee" class="hoverObject">Medewerker toevoegen</label>
                <button id="open_add_employee" data-toggle="modal" data-target="#add_employee" class="rounded-circle btn-secondary" style="border: none;"><i class="fas fa-plus px-1"></i></button>
                <company-add-employee :departmentName="departmentName" :selectedDepartment="selectedDepartment" v-on:added-employees="reloadUsers"></company-add-employee>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            selectedDepartment: Number,
        },
        data: function () {
            return {
                users: [],
                subusers: [],
                defaultMsg: "Selecteer een afdeling om de werknemers hiervan in te zien.",
                departmentName: "",
            }
        },
        watch: {
            selectedDepartment: {
                handler: function (data) {
                    if (data == null) {
                        this.users = []
                        this.departmentName = this.defaultMsg;
                        $('#headerDepartmentName').toggleClass('font-italic');
                    } else {
                        this.getEmployees(data);
                    }
                },
                deep: true
            },
        },
        beforeMount() {
            this.departmentName = this.defaultMsg;
        },
        methods: {
            /**
             *
             * Get data
             *
             */
            getEmployees(departmentID) {
                $.ajax({
                    type : 'GET',
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    dataType: 'json',
                    url : `get-employees`,
                    data:{
                        id: departmentID,
                    },
                    success: this.changeShownUsers,
                });
            },
            reloadUsers() {
                this.getEmployees(this.selectedDepartment);
            },
            /**
             *
             * Callbacks
             *
             */
            changeShownUsers(event) {
                this.users = event.users;
                this.subusers = event.subusers;
                this.departmentName = event.departmentName;
                if ($('#headerDepartmentName').hasClass('font-italic')) $('#headerDepartmentName').toggleClass('font-italic');
            },
            removedEmployee() {
                this.reloadUsers();
            },
            /**
             *
             * Events
             *
             */
            removeEmployee(id) {
                $.ajax({
                    type : 'DELETE',
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    dataType: 'json',
                    url : `delete-employee`,
                    data:{
                        id: id,
                    },
                    success: this.removedEmployee,
                });
            },
        },
    }
</script>
